import { _post } from "@/utils/request.js";
const preApi = process.env.NODE_ENV !== "production" ? "/api" : process.env.VUE_APP_API;
const URL = {
  videoBgRemove: preApi + "/ai/video_remove/generate",
};
const getVideoBgRemove = async (data) => _post(URL.videoBgRemove, data);
export { getVideoBgRemove };